import { compose } from 'redux';
import { connect } from 'react-redux';
import selectors from '../../../rootSelectors';
import { clearResponses } from '../../mazeActions';
import { setAvatarInstructions } from '../../../common/avatar/avatarActions';
import { stopAudio } from '../../../common/audio/audioActions';
import {
    unmountScreen,
    blockScreen,
    unblockScreen,
    colorInScreen,
    greyOutScreen,
} from '../../../common/screen/screenActions';
import { onResponseSelected, playDirectionsScript, playModelScript } from './MazeModelActions';
import { MODEL } from '../../../constants/assessmentItemType';
import { goToPractice } from '../../../common/navigation/navigationActions';
import withAvatar from '../../../common/avatar/withAvatar';
import AvatarView from '../../../common/avatar/avatarView';
import { getAvatarPosition } from '../../../common/alex/AlexUtils';
import MazeModelView from './MazeModelView';
import { setLanguageForMeasure } from '../../../common/utils/languageUtils';

const mapStateToProps = (state, ownProps) => ({
    isScreenBlocked: selectors.getIsScreenBlocked(state),
    isNextButtonActive: selectors.getIsNextButtonActive(state),
    isGreyedOut: selectors.getIsScreenGreyedOut(state),
    isDataFetched: selectors.getIsMazeDataFetched(state),
    paragraphs: selectors.getMazeParagraphs(state, MODEL),
    questions: selectors.getMazeQuestionItems(state, MODEL),
    title: selectors.getMazeTitle(state, MODEL),
    selectedResponses: selectors.getMazeSelectedResponses(state),
    isExtendedView: ownProps.isExtendedView,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchContent: () => {
        dispatch(ownProps.flowStrategy.fetchContent());
        setLanguageForMeasure(dispatch, ownProps.flowStrategy);
    },
    narrateScreen: () => {
        dispatch(greyOutScreen());
        dispatch(blockScreen());
        const { instructions } = ownProps.flowStrategy;
        return dispatch(playDirectionsScript(instructions[MODEL]))
            .then(() => {
                dispatch(setAvatarInstructions(instructions[MODEL].modelIncorrectResponse));
                dispatch(colorInScreen());
                return dispatch(playModelScript(instructions[MODEL]));
            })
            .then(() => {
                dispatch(unblockScreen());
            });
    },
    onResponseSelected: (questionId, responseId) => {
        dispatch(
            onResponseSelected(questionId, responseId, ownProps.flowStrategy.instructions[MODEL]),
        );
    },
    cleanup: () => {
        dispatch(stopAudio());
        dispatch(clearResponses());
        dispatch(unmountScreen());
    },
    onNext: () => {
        dispatch(goToPractice(ownProps.flowStrategy.assessment));
    },
});

const avatarMapStateToProps = (_, ownProps) => {
    const { isExtendedView } = ownProps;
    const positionConfig = {
        alyxPosition: AvatarView.Position.TOP_HEADER_CENTER,
        extendedViewPosition: AvatarView.Position.LOWER_FAR_LEFT,
        defaultViewPosition: AvatarView.Position.MIDDLE_LEFT,
    };
    const position = getAvatarPosition(positionConfig, isExtendedView);
    return {
        position,
        animateAlex: true,
    };
};

const MazeModelContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(MazeModelView);

export default MazeModelContainer;
